const PRIORITIZATION_TEMPLATE_REGEX = /road\W?map/i;
const PIR_TEMPLATE_REGEX = /(p[oa]st\s*incidents?\s*reviews?)|((\bPIR\b))/i;
const TEAM_FORMATION_TEMPLATE_REGEX =
	/(.+?((roles?)|(responsibilit(y|ies))).*)|(.+?((responsibilit(y|ies)|(roles?))).*)/i;

export enum WhiteboardTemplates {
	PRIORITIZATION = 'confluence_collaborate_template_14',
	PIR = 'confluence_collaborate_template_15',
	TEAM_FORMATION = 'confluence_collaborate_template_16',
}

export const isEligibleForWhiteboardDiscovery = (pageTitle: string): boolean => {
	if (PRIORITIZATION_TEMPLATE_REGEX.test(pageTitle)) return true;
	if (PIR_TEMPLATE_REGEX.test(pageTitle)) return true;
	if (TEAM_FORMATION_TEMPLATE_REGEX.test(pageTitle)) return true;
	return false;
};

export const getWhiteboardTemplateByPageTitle = (pageTitle: string): WhiteboardTemplates => {
	if (PRIORITIZATION_TEMPLATE_REGEX.test(pageTitle)) return WhiteboardTemplates.PRIORITIZATION;
	if (PIR_TEMPLATE_REGEX.test(pageTitle)) return WhiteboardTemplates.PIR;
	if (TEAM_FORMATION_TEMPLATE_REGEX.test(pageTitle)) return WhiteboardTemplates.TEAM_FORMATION;

	// Arbitrarily pick this template as the default template
	return WhiteboardTemplates.PRIORITIZATION;
};
